export default {
  User: {
    username: "Username",
    password: "Password"
  }
}